import { createSelector } from 'reselect'

import { getCockpitPlanningStarted, isCockpitPlanningStarted } from '../../lib'

import { selectCockpitCompletenessData } from './selectCockpitCompletenessData'
import { selectCockpitOffering } from './selectCockpitOffering'
import { selectVisibleCockpitPartnerData } from './selectVisibleCockpitPartnerData'

/** Planning status of the partners the cockpit shows. Plan Quality has nothing to score before
 *  planning starts, so it is hidden rather than shown as a 0. */
export const selectCockpitPlanningStarted = createSelector(
  [selectCockpitCompletenessData, selectVisibleCockpitPartnerData],
  (completenessData, partners) =>
    getCockpitPlanningStarted(
      completenessData,
      partners.map(({ PartnerId }) => PartnerId)
    )
)

export const selectIsCockpitPlanningStarted = createSelector(
  [selectCockpitPlanningStarted, selectCockpitOffering],
  isCockpitPlanningStarted
)
